import { PropertySearchResult } from '../../types/propertySearch';
import getFormattedPrice from '../property/getFormattedPrice';
import puralise from '../puralise';

const getTotalProperties = (category: string, result?: PropertySearchResult) => {
  if (result) {
    if (category === 'newhomes') {
      return [
        puralise('development', 'developments', result.totalDevelopments),
        getFormattedPrice(result.totalDevelopments, ''),
      ];
    }

    return [puralise('property', 'properties', result.totalUnits), getFormattedPrice(result.totalUnits, '')];
  }

  return ['', ''];
};

export default getTotalProperties;
